import { POST_ANNOUNCEMENTS, POST_ANNOUNCEMENTS_SUCCESS, POST_ANNOUNCEMENTS_ERROR, POST_ANNOUNCEMENTS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateAnnoucement = (state = initialState, action) => {
  switch (action.type) {
    case POST_ANNOUNCEMENTS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case POST_ANNOUNCEMENTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case POST_ANNOUNCEMENTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case POST_ANNOUNCEMENTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateAnnoucement;
